////////////////////////////////////////////////////////////////////////////////
// Listen
////////////////////////////////////////////////////////////////////////////////

class Listen {

	constructor() {

		this.functions = [];
		this.first = true;

	}

	// Add Function --------------------------------------------------------------
	// Add an action/function to occur on each window scroll/resize event
	// movement.add(() => { ... })

	for() {

		let func = null;
		let name = null;

		Array.prototype.slice.call(arguments).forEach((arg) => {
			if ( typeof arg == 'function') {
				func = arg;
			} else if (typeof arg == 'string') {
				name = arg;
			}
		});

		// Fallback name if one wasn't passed

		if (name == null) {
			name = `action-${(this.functions.length + 1)}`;
		}

		// Only set the window listener if at least one movement function has been added.
		if ( this.first ) {
			$(window).on('scroll resize', () => {
				this.run()
			})
			this.first = false;
		}

		if ( typeof func == 'function' ) {
			this.functions[name] = func;
			this.run();
		}
	}

	// List out all active function names ----------------------------------------

	list() {
		return Object.keys(this.functions);
	}

	// Remove Function -----------------------------------------------------------
	// Delete a function from the functions array by name

	remove(name) {
		delete this.functions[name];
	}

	// Run Functions -------------------------------------------------------------
	// Run all cached functions

	run() {
		if ( typeof this.functions !== 'undefined' ) {

			Object.entries(this.functions).forEach(([name, func]) => {
			  func(name);
			});

		}
	}

}
